<template>
    <div>

        <div class="container-fluid section-middle staticnews">
            <div class="row row-newsletter staticPage">
                <div class="col-sm-12 col-md-12">
                    <h2 class="h2-produce">Newsletter signup</h2>

                    <!-- onsubmit -->
                    <form action="//gracelinks.us1.list-manage.com/subscribe/post?u=49e434a0e4c33f0720cb12be5&amp;id=d8918a9897" method="post"
                    id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" @submit="checkForm">

                        <p v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                            <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>

                        <div id="mc_embed_signup_scroll">
                            <p id="about-intro">Get more information about seasonal and sustainable food by signing up for emails from <a class="seasonality-link" target="_blank" href="https://foodprint.org">FoodPrint.</a>
                            By subscribing to these communications, you are agreeing to receive emails from us. We promise not to email you too often or sell your information.  </p>

                            <div class="mc-field-group form-group">
                                <!-- <label class="sr-only" htmlFor="mce-FNAME">First Name </label> -->
                                <input type="text" name="FNAME" class="form-control" id="mce-FNAME" v-model="mceFNAME" placeholder="First name"/>
                            </div>
                            <div class="mc-field-group form-group">
                                <!-- <label class="sr-only" htmlFor="mce-LNAME">Last Name</label> -->
                                <input type="text" name="LNAME" class="form-control" id="mce-LNAME" v-model="mceLNAME" placeholder="Last name"/>
                            </div>
                            <div class="mc-field-group form-group">
                                <!-- <label class="sr-only" htmlFor="mce-EMAIL">Email Address <span class="asterisk">*</span></label> -->
                                <input type="email" name="EMAIL" class="required email form-control" id="mce-EMAIL" v-model="mceEMAIL" placeholder="*E-mail address"/>
                            </div>
                            <div class="mc-field-group input-group">
                                <div id="form-check-wrapper">
                                    <div class="form-check">
                                        <p><input type="checkbox" id="privacypolicy" v-model="privacypolicy" class="form-check-input newsletter-checkbox">
                                        <label class="form-check-label" for="privacypolicy">*I have read and accept the <a href="https://foodprint.org/privacy-and-terms-of-use" target="_blank">privacy policy.</a></label></p>
                                    </div>
                                </div>
                            </div>
                            <div id="mce-responses" class="clear">
                                <div class="response hidden" id="mce-error-response" />
                                <div class="response hidden" id="mce-success-response"/>
                            </div>
                            <div class="displaced" aria-hidden="true">
                                <input type="text"
                                    name="b_49e434a0e4c33f0720cb12be5_d8918a9897" tabIndex="-1" value=""/>
                            </div>
                            <div class="clear">
                                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="btn-outline-primary"/>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            errors: [],
            mceFNAME: null,
            mceLNAME: null,
            mceEMAIL: null,
            privacypolicy: false
        }
    },
    methods:{
        checkForm: function (e) {
        if (this.mceEMAIL && this.privacypolicy) {
            return true;
        }

        this.errors = [];

        if (!this.mceEMAIL) {
            this.errors.push('Please enter your email address.');
        }

        if (!this.privacypolicy) {
            this.errors.push('To sign up for the newsletter you must accept the privacy policy.');
        }

        e.preventDefault();
        }
    },
    // mounted: function () {
    //     this.$nextTick(function () {
    //         (window.innerWidth<=940) ? this.$scrollToTop(10) : this.$scrollToTop(388)
    //     })
    // }
}
</script>



<style scoped>
.btn-outline-primary {
    width: 130px;
}
.btn-outline-primary:hover {
    color: white
}
.clear {
    margin-top: 50px
}
.form-control {
    display: block;
    width: 100%;
    height: 30px;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    margin-top: 20px
}
</style>

